import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=72b1232c&scoped=true&"
import script from "./TextInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=72b1232c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1232c",
  null
  
)

export default component.exports